<template>
  <div>
    <div class="primary--text font-weight-bold ml-2">
      {{ label }}{{ ruleRequired ? "*" : "" }}
    </div>
    <v-text-field
      v-if="type != 'phone' && type != 'select'"
      class="rounded-lg"
      ref="input"
      :messages="messages"
      dense
      outlined
      :suffix="suffix"
      :type="type"
      :error="error"
      :rules="rulesGenerated"
      :placeholder="placeholder"
      :readonly="disabled"
      :error-messages="errorMessages"
      :value="value"
      @focus="$emit('focus')"
      @keyup="$emit('keyup', $event)"
      @update:error="errorMode = $event"
      @input="input"
    >
      <template v-slot:message>
        <slot name="message"></slot>
      </template>
      <template v-slot:prepend-inner>
        <slot name="prepend-inner"></slot>
      </template>
      <template v-slot:append>
        <slot name="append" v-if="!loading">
          <v-icon
            v-if="!iconAppend"
            :color="icon.color"
            class="material-icons-outlined"
            >{{ icon.icon }}</v-icon
          >
          <v-icon
            v-else
            :color="iconAppendColor"
            class="material-icons-outlined"
            >{{ iconAppend }}</v-icon
          >
        </slot>
        <v-progress-circular
          v-else
          indeterminate
          size="20"
          color="primary"
        ></v-progress-circular>
      </template>
    </v-text-field>
    <v-select
      v-if="type === 'select'"
      class="rounded-lg"
      ref="input"
      :messages="messages"
      dense
      outlined
      :item-text="itemText"
      :item-value="itemValue"
      :suffix="suffix"
      :error="error"
      :rules="rulesGenerated"
      :items="items"
      :placeholder="placeholder"
      :readonly="disabled"
      :value="value"
      @focus="$emit('focus')"
      @update:error="errorMode = $event"
      @input="input"
    >
      <template v-slot:message>
        <slot name="message"></slot>
      </template>
      <template v-slot:prepend-inner>
        <slot name="prepend-inner"></slot>
      </template>
      <template v-slot:append v-if="value">
        <slot name="append" v-if="!loading">
          <v-icon
            v-if="!iconAppend"
            :color="icon.color"
            class="material-icons-outlined"
            >{{ icon.icon }}</v-icon
          >
          <v-icon
            v-else
            :color="iconAppendColor"
            class="material-icons-outlined"
            >{{ iconAppend }}</v-icon
          >
        </slot>
        <v-progress-circular
          v-else
          indeterminate
          size="20"
          color="primary"
        ></v-progress-circular>
      </template>
    </v-select>
    <div v-if="type === 'phone'">
      <MazPhoneNumberInput
        :disabled="disabled"
        placeholder=" "
        ref="phonefield"
        no-example
        @update="update"
        :value="value"
        @input="input"
      />
      <div class="ml-3 error--text caption" v-if="!isValid">
        {{ this.$t("sc.required") }}
      </div>
    </div>
  </div>
</template>

<script>
import { MazPhoneNumberInput } from "maz-ui";
export default {
  components: {
    MazPhoneNumberInput,
  },
  props: {
    value: [String,Object,Number],
    label: String,
    iconAppend: String,
    iconAppendColor: String,
    messages: String,
    disabled: Boolean,
    error: Boolean,
    errorMessages: [String, Array],
    placeholder: String,
    suffix: String,
    type: String,
    ruleRequired: Boolean,
    ruleEmail: Boolean,
    ruleMaxLength: Number,
    ruleMinLength: Number,
    ruleSpecialCharacters: Boolean,
    loading: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemText: String,
    itemValue: String
  },
  data: (vm) => ({
    errorMode: false,
    rulesList: [
      {
        ruleRequired: (v) => !!v || vm.$t("sc.required"),
      },
      {
        ruleEmail: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          vm.$t("sc.invalid-email"),
      },
      {
        ruleMaxLength: (v) =>
          v?.length <= vm.ruleMaxLength ||
          vm.$t("sc.max-limit", { limit: vm.ruleMaxLength }),
      },
      {
        ruleMinLength: (v) =>
          v?.length >= vm.ruleMinLength ||
          vm.$t("sc.min-limit", { limit: vm.ruleMinLength }),
      },
      {
        ruleSpecialCharacters: (v) =>
         !/[^A-Z0-9]/gi.test(v) || vm.$t("sc.special-characters"),
      },
      {
        rules: vm.rules,
      },
    ],
    isValid: true,
  }),
  mounted() {
    if (this.type === "phone")
      this.$refs.phonefield.asYouTypeNumber = this.value;
  },
  computed: {
    rulesGenerated: (vm) =>
      // Se concatena las reglas definidas en las propiedades
      vm.rulesList.reduce(
        (acc, curr) =>
          vm[Object.keys(curr)[0]]
            ? acc.concat(curr[Object.keys(curr)[0]])
            : acc,
        []
      ),
    icon: (vm) =>
      !vm.errorMode
        ? vm.value
          ? { icon: "check_circle", color: "green" }
          : { icon: "check_circle", color: "grey" }
        : { icon: "error_outline", color: "red" },
  },
  methods: {
    validate() {
      this.isValid = this.$refs.phonefield.isValid;
      return this.isValid;
    },
    input(e) {
      this.$emit("input", e);
    },
    update(e) {
      if (this.value?.length > 0) this.isValid = true;
      this.$emit("update", e);
    },
  },
};
</script>
